module.exports = __webpack_public_path__ + "img/creative-commons-sampling.70b9699a.svg";